module.exports = __webpack_public_path__ + "img/houdini-kid-magic.dd2b7e7.jpg";